<template>
  <div id="entire_app__container">
    <div
      v-if="$store.state.SidebarToggle.loadingPageData"
      :class="{
        '--booking_in_progress': $store.state.SidebarToggle.loadingPageData,
      }"
      class="ticket_booking_order"
    >
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="" />
          <img class="loader" src="../../assets/loading.gif" alt="" />
        </div>
      </div>
    </div>
    <div
      class="entire_app__sidebar_container"
      :class="{
        '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <AdminSidebar />
    </div>
    <div
      class="entire_app_mobile_sidebar_container"
      v-if="$store.state.Customizations.mobile_siderbar_toggled"
    >
      <admin-mobile-sidebar />
    </div>

    <div class="__mobile_navigation">
      <div class="logo_container">
        <div class="menu_toggle">
          <svg
            id="menu"
            @click="$store.commit('Customizations/togglemobilesidebar')"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 28 28"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H28V28H0Z"
              fill="none"
            />
            <path
              id="Path_2"
              data-name="Path 2"
              d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z"
              transform="translate(0)"
              fill="#1d2329"
            />
          </svg>
        </div>
        <div class="logo">
          <img src="../../assets/logo.png" alt="logo" />
        </div>
        <div class="settings">
          <router-link to="/admin/profile"
            ><svg
              @click="
                $store.commit('Customizations/togglemobilesidebartofalse')
              "
              id="settings"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 28 28"
            >
              <path
                id="Path_3"
                data-name="Path 3"
                d="M0,0H28V28H0Z"
                fill="none"
              />
              <path
                id="Path_4"
                data-name="Path 4"
                d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z"
                transform="translate(0 0)"
                fill="#1d2329"
              /></svg
          ></router-link>
        </div>
      </div>
    </div>

    <div
      class="entire_app__page_content"
      :class="{
        '--sidebar_toggled_expd_body':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <div class="today">
        <h5>
          <svg
            id="pulse-fill"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Path_31"
              data-name="Path 31"
              d="M0,0H24V24H0Z"
              fill="none"
            />
            <path
              id="Path_32"
              data-name="Path 32"
              d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
              fill="#1d2329"
            />
          </svg>
          Dashboard
        </h5>
        <div class="branches_performance">
          <div class="performance_today">
            <div class="heading my-1">
              <h6 class="graphs-heading-text ml-3">Today's performance</h6>
            </div>
            <hr />
            <div class="boxes">
              <div class="three">
                <div class="box1 tickets">
                  <div class="essentials">
                    <p class="number">{{ report.count }}</p>
                    <h4>Tickets sold</h4>
                  </div>
                  <img
                    v-if="report.count > yesterday.count"
                    src="@/assets/increase.svg"
                  />
                  <img v-else src="@/assets/decrease.svg" />
                </div>
                <div class="box1 funds">
                  <div class="essentials">
                    <p class="number">{{ report.total_fund }}</p>
                    <h4>Funds</h4>
                  </div>
                  <img
                    v-if="report.total_fund > yesterday.total_fund"
                    src="@/assets/increase.svg"
                  />
                  <img v-else src="@/assets/decrease.svg" />
                </div>
                <div class="box1 transactionns">
                  <div class="essentials">
                    <p class="number">{{ report.count }}</p>
                    <h4>Transactions</h4>
                  </div>
                  <img
                    v-if="report.count > yesterday.count"
                    src="@/assets/increase.svg"
                  />
                  <img v-else src="@/assets/decrease.svg" />
                </div>
                <div class="box1 journeys">
                  <div class="essentials">
                    <p class="number2">
                      {{ highlyPerformantBranch }} branch &nearr;
                    </p>
                    <h4>{{ lessPerformantBranch }} branch &searr;</h4>
                  </div>
                </div>
                <!-- <div class="box1 journeys">
                  <div class="essentials">
                    <p class="number">2</p>
                    <h4>Journeys</h4>
                  </div>
                  <img src="@/assets/increase.svg" />
                </div> -->
                <div @click.prevent="downloadPDF" class="box1 issues">
                  <div class="essentials">
                    <h4>Get Company Info</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <square loading="isLoading"></square>
          <div class="day d-flex">
            <div class="branches_today col-lg-7 pb-4">
              <div class="bordered">
                <div class="title">
                  <h6>Branches today</h6>
                  <p class="money">
                    {{ report.total_fund }} {{ report.currency }}
                  </p>
                </div>
                <p class="small_p">Total money raised today</p>
              </div>
              <div class="charts reduced bg-white">
                <Brancheschart />
              </div>
            </div>

            <div class="details-container p">
              <div class="heading my-3">
                <h6 class="graphs-heading-text ml-3">All time stats</h6>
              </div>
              <hr />
              <div class="actionn d-flex mt-3">
                <div class="rd-1">Total amount Earned</div>
                <div class="rd-2 my-auto">
                  {{ alltimemoney }} {{ currency }}
                </div>
              </div>
              <div class="actionn d-flex">
                <div class="rd-1">Total tickets sold</div>
                <div class="rd-2 my-auto">{{ alltimetickets }}</div>
              </div>
              <div class="actionn d-flex">
                <div class="rd-1">Highly perfomant branch</div>
                <div class="rd-2 my-auto">{{ alltimehigh }}</div>
              </div>
              <div class="actionn d-flex">
                <div class="rd-1">Less perfomant branch</div>
                <div class="rd-2 my-auto">{{ alltimelow }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5 class="ml-4 my-2 title2">Last week's perfomance</h5>
      <div class="nolastweek bg-light mx-auto" v-if="nolastWeek">
        <p class="text-center py-3">
          There are no previous week transaction for your company
        </p>
      </div>
      <div class="lastweek d-flex" v-if="lastweekSectionShow">
        <div class="branches-contribution part-one">
          <div class="heading my-3">
            <h6 class="graphs-heading-text ml-3">
              Branches contribution to the funds
            </h6>
          </div>
          <hr />
          <div class="percentages-and-funds">
            <div class="sub-heading">
              <p class="p-2">Percentages and funds</p>
              <piechart />
            </div>
          </div>
          <div class="day-to-day-contribution">
            <div class="sub-heading">
              <p class="p-2">Day to day contribution of each branch</p>
            </div>
            <DayToDay />
          </div>
        </div>
        <div class="part-two">
          <div class="Income-generation">
            <div class="heading py-3">
              <h6 class="graphs-heading-text ml-3">Income generation</h6>
            </div>
            <hr />
            <div class="income-gen-graph">
              <BranchesContribution />
            </div>
          </div>
          <div class="sold-tickets">
            <div class="heading py-3">
              <h6 class="graphs-heading-text ml-3">Sold Tickets</h6>
            </div>
            <hr />
            <div class="sold-tickets-graph">
              <SoldTickets />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Brancheschart from "./dashboardComponents/brancheschart.vue";
import AdminSidebar from "@/components/adminSidebar.vue";
import AdminMobileSidebar from "@/components/AdminMobileSidebar.vue";
import BranchesContribution from "./dashboardComponents/branchesCont.vue";
import piechart from "./dashboardComponents/piechart.vue";
import DayToDay from "./dashboardComponents/day-day.vue";
import SoldTickets from "./dashboardComponents/soldTickets.vue";
import jwt_decode from "jwt-decode";
import router from "../../router/index";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { capitalize } from "lodash";

const lastWeekApi =
  "https://bookinga.herokuapp.com/api/v1/adminReport/company/lastweek";
const totalFund =
  "https://bookinga.herokuapp.com/api/v1/adminReport/fund/company";
const branchPercentage =
  "https://bookinga.herokuapp.com/api/v1/adminReport/company/branchpecentage";
import axios from "axios";
import { Vue, Options } from "vue-class-component";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
@Options({
  components: {
    AdminSidebar,
    Brancheschart,
    BranchesContribution,
    piechart,
    DayToDay,
    SoldTickets,
    AdminMobileSidebar,
  },
  data() {
    return {
      isloading: true,
      highlyPerformantBranch: "",
      lessPerformantBranch: "",
      lastweekSectionShow: false,
      nolastWeek: false,
      report: [],
      yesterday: [],
      alltimetickets: "",
      alltimemoney: "",
      currency: "",
      alltimehigh: "",
      alltimelow: "",

      drivers: [],
      shalois: [],
      bps: [],
      buses: [],
      branches: [],
      company_name: "",
      branch_info: [],
      drivers_info: [],
      shalois_info: [],
      buses_info: [],
      breakpoint_info: [],
    };
  },
  created() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if(userRole!="admin"){
       return router.push("/dashboard")
     }
  },
  mounted() {
    axios
      .get("https://bookinga.herokuapp.com/api/v1/company/admin/info", config)
      .then((res) => {
        // console.log(res.data, "david");
        //drivers
        this.drivers = res.data.drivers;
        for (let i = 0; i < this.drivers.length; i++) {
          this.drivers_info[i] = [];
          this.drivers_info[i][0] = this.drivers[i].firstname;
          this.drivers_info[i][1] = this.drivers[i].lastname;
          this.drivers_info[i][2] = this.drivers[i].email;
          this.drivers_info[i][3] = this.drivers[i].phonenumber;
        }

        //shalois
        this.shalois = res.data.shalois;
        for (let i = 0; i < this.shalois.length; i++) {
          this.shalois_info[i] = [];
          this.shalois_info[i][0] = this.shalois[i].firstname;
          this.shalois_info[i][1] = this.shalois[i].lastname;
          this.shalois_info[i][2] = this.shalois[i].email;
          this.shalois_info[i][3] = this.shalois[i].phonenumber;
        }

        //breakpoints
        this.bps = res.data.breakpoints;
        for (let i = 0; i < this.bps.length; i++) {
          this.breakpoint_info[i] = [];
          this.breakpoint_info[i][0] = this.bps[i].source;
          this.breakpoint_info[i][1] = this.bps[i].destination;
          this.breakpoint_info[i][2] = this.bps[i].price;
        }

        //buses
        this.buses = res.data.buses;
        for (let i = 0; i < this.buses.length; i++) {
          this.buses_info[i] = [];
          this.buses_info[i][0] = this.buses[i].busplatenumber;
          this.buses_info[i][1] = this.buses[i].capacity;
          this.buses_info[i][2] =
            this.buses[i].firstname + " " + this.buses[i].lastname;
        }

        //branches
        this.branches = res.data.branches;
        for (let i = 0; i < this.branches.length; i++) {
          this.branch_info[i] = [];
          this.branch_info[i][0] = this.branches[i].branchname;
          this.branch_info[i][1] = this.branches[i].office_location;
          this.branch_info[i][2] =
            this.branches[i].firstname + " " + this.branches[i].lastname;
        }

        //companyname
        this.company_name = capitalize(res.data.name);
      });

    axios.get(totalFund, config).then((res) => {
      this.report = res.data.data[0];
    });

    axios
      .get(
        "https://bookinga.herokuapp.com/api/v1/adminReport/fund/company/yesterday",
        config
      )
      .then((res) => {
        this.yesterday = res.data.data[0];
      });
    axios
      .get(branchPercentage, config)
      .then((res) => {
        // console.log(res.data.message);
        var branchesAmounts = [];
        for (let i = 0; i < res.data.data.length; i++) {
          branchesAmounts.push(res.data.data[i].sum);
        }
        var lowNumber = this.findLowNumber(branchesAmounts);
        var higherNumber = this.findMaxNumber(branchesAmounts);
        if (lowNumber == higherNumber) {
          this.highlyPerformantBranch = capitalize(res.data.data[0].branchname);
          this.lessPerformantBranch = "None";
        } else {
          for (let j = 0; j < res.data.data.length; j++) {
            if (res.data.data[j].sum == higherNumber) {
              this.highlyPerformantBranch = capitalize(
                res.data.data[j].branchname
              );
            }
            if (res.data.data[j].sum == lowNumber) {
              this.lessPerformantBranch = capitalize(
                res.data.data[j].branchname
              );
            }
          }
        }
      })
      .catch((err) => {
        (this.lessPerformantBranch = "None"),
          (this.highlyPerformantBranch = "None");
      });

    //all time stats
    axios
      .get(
        "https://bookinga.herokuapp.com/api/v1/adminReport/fund/company/allTimeReport",
        config
      )
      .then((res) => {
        this.alltimetickets = res.data.companyFund[0].count + " tickets";
        this.alltimemoney = res.data.companyFund[0].total_fund;
        this.currency = res.data.companyFund[0].currency;

        var alltimebranchesAmounts = [];
        for (let i = 0; i < res.data.percentageByBranch.length; i++) {
          alltimebranchesAmounts.push(res.data.percentageByBranch[i].sum);
        }
        // console.log(alltimebranchesAmounts, "alltimebranchesAmounts");
        var alltimelowNumber = this.findLowNumber(alltimebranchesAmounts);
        var alltimehigherNumber = this.findMaxNumber(alltimebranchesAmounts);

        for (let j = 0; j < res.data.percentageByBranch.length; j++) {
          if (res.data.percentageByBranch[j].sum == alltimelowNumber) {
            this.alltimelow = capitalize(
              res.data.percentageByBranch[j].branchname
            );
          } else if (
            res.data.percentageByBranch[j].sum == alltimehigherNumber
          ) {
            this.alltimehigh = capitalize(
              res.data.percentageByBranch[j].branchname
            );
          }
        }
      })
      .catch((err) => {
        // console.error(err);
        (this.alltimetickets = "-"),
          (this.alltimemoney = "-"),
          (this.alltimehigh = "None"),
          (this.alltimelow = "None");
      });

    axios.get(lastWeekApi, config).then((res) => {
      if (res.data.message == "No last week's transactions") {
        (this.lastweekSectionShow = false), (this.nolastWeek = true);
      } else {
        this.lastweekSectionShow = true;
        this.nolastWeek = false;
      }
    });
  },
  methods: {
    downloadPDF() {
      var pdf = new jsPDF();
      pdf.text(this.company_name, 90, 10);

      //drivers
      pdf.autoTable({
        head: [["DriverFirstname", "DriverLastname", "Email", "Phonenumber"]],
        body: [...this.drivers_info],
      });

      //shalois
      pdf.autoTable({
        head: [["ShaloiFirstname", "ShaloiLastname", "Email", "Phonenumber"]],
        body: [...this.shalois_info],
      });

      //buses
      pdf.autoTable({
        head: [["Busplateno", "Sits", "driver"]],
        body: [...this.buses_info],
      });

      //branches
      pdf.autoTable({
        head: [["BranchName", "Location", "shaloi"]],
        body: [...this.branch_info],
      });

      //breakpoints
      pdf.autoTable({
        head: [["RouteSource", "RouteDestination", "Price"]],
        body: [...this.breakpoint_info],
      });

      pdf.save(`${this.company_name}-bookinga.pdf`);
    },
    findLowNumber(array) {
      if (array.length == 0) {
        return 0;
      }
      return Math.min.apply(Math, array);
    },
    findMaxNumber(array) {
      if (array.length == 0) {
        return 0;
      }
      return Math.max.apply(Math, array);
    },
  },
})
export default class AdminDashboard extends Vue {}
</script>

<style lang="scss" scoped>
.actionn {
  background-color: #ffffff;
  padding: 10px 0;
  height: 9vh;
  margin: 5px 20px;
  // height: fit-content;
  font-size: 13px;
  border-radius: 5px;
  box-shadow: 0 0 3px 1px #fafbfc;
}
.actionn:nth-child(odd) {
  background-color: #f4f6f9;
}
.rd-1 {
  padding-left: 10px;
  width: 60%;
  margin: auto;
  // background-color: #9378e4;
}
.rd-2 {
  width: 40%;
  // background-color: yellowgreen;
}
.income-gen-graph,
.sold-tickets-graph {
  background-color: white;
  width: 95%;
  margin: 10px auto;
}
.day-to-day-contribution,
.percentages-and-funds {
  margin: 10px;
  background-color: white;
}
.day-to-day-contribution {
  height: 50%;
}
.percentages-and-funds {
  height: 38%;
}
.part-one,
.part-two {
  width: 49%;
  margin: 10px;
}
.part-one {
  border-radius: 10px;
  height: 60em;
  background-color: #fafbfc;
}
.part-two {
  height: 60em;
}
.details-container {
  background-color: #fafbfc;
  border-radius: 10px;
  width: 38%;
  margin: 0 auto;
}
.sold-tickets,
.Income-generation {
  border-radius: 10px;
  height: 49%;
  background-color: #fafbfc;
}
.sold-tickets {
  margin-top: 10px;
  height: 50%;
}
#entire_app__container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

   .--booking_in_progress {
      display: block !important;
    }

   .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100vh;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }

      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
      }
    }
  }

  .entire_app_mobile_sidebar_container {
    display: none;
  }

  .__mobile_navigation {
    display: none;
  }
  .--sidebar_toggled {
    width: 6.5% !important;
    height: 100% !important;
  }
  .--sidebar_toggled_expd_body {
    width: 93.5% !important;
  }
  & .entire_app__sidebar_container {
    width: 17%;
    height: 100%;
    background: $mainDimBlue;
    transition: 0.2s ease;
  }
  & .entire_app__page_content {
    width: 83%;
    height: 100%;
    background: $pureWhite;
    transition: 0.2s ease;
    font-family:satoshi, $poppins !important;
    overflow-y: scroll !important;
    .today {
      width: 100%;
      height: 100vh;
      margin-bottom: 1vh;
      display: flex;
      flex-direction: column;
      h5 {
        color: $gradientDark;
        margin-top: 0.5%;
        margin-bottom: 0.5%;
        margin-left: 1%;
        font-size: 0.9em;
      }
      .branches_performance {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .performance_today {
          background-color: $adminCards;
          border-radius: 5px;
          width: 98%;
          height: 45%;
          padding: 1% !important;
          margin-left: 1%;
          margin-bottom: 1%;

          .boxes {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 97%;
            justify-content: center;
            .three {
              margin-bottom: 1.5%;
              display: flex;
              justify-content: space-around;
              height: 55%;
              width: 100%;
              .tickets {
                background: linear-gradient(90deg, #a9dbff, #199fff);
              }
              .funds {
                background: linear-gradient(90deg, #2af7df, #449bf8);
              }
              .transactionns {
                background: linear-gradient(90deg, #ffcfa4, #fd7689);
              }
              .journeys {
                background: linear-gradient(90deg, #febe9f, #c0357bb0);
              }
              .issues {
                background: linear-gradient(90deg, #ea98e5, #6f69f6);
                cursor: pointer;
              }
              .box1 {
                width: 18%;
                height: 100%;
                border-radius: 5px;
                padding: 0.5% 1%;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                h4 {
                  font-size: 0.9em;
                  color: $pureWhite;
                  font-weight: 400;
                }
                .number {
                  font-weight: bold;
                  font-size: 1.2em;
                  color: $pureWhite;
                }
                .number2 {
                  font-weight: bolder;
                  font-size: 1em;
                  color: $pureWhite;
                }
                .compare {
                  font-size: 0.8em;
                  text-align: center;
                  color: #fff;
                }
              }
            }
          }
        }
        .day {
          height: 100%;
        }
        .branches_today {
          background-color: $adminCards;
          border-radius: 5px;
          width: 98%;
          height: 100%;
          padding: 1%;
          margin-left: 1%;
          overflow: auto;

          .money {
            font-weight: bold;
            font-size: 0.9em;
          }
          .small_p {
            text-align: right !important;
            font-size: 0.85em;
          }
          .reduced {
            height: 88% !important;
          }
        }
      }
      .bordered {
        border-bottom: 1px solid $mainDimBlue !important;
      }
      .title {
        display: flex;
        justify-content: space-between;
        h6 {
          color: $gradientDark;
          font-size: 0.89em;
        }
        .money {
          font-size: 0.8em;
        }
      }
      .charts {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      .customer_transactionn {
        margin: 1% 1% 0 1%;
        background-color: $adminCards;
        border-radius: 5px;
        width: 98%;
        height: 44.5%;
        padding: 1%;
        .extended {
          height: 97% !important;
        }
      }
    }
  }
}
@media only screen and (max-width: 600px) {
	#entire_app__container {
    height: auto;

    .ticket_booking_order {
      .ticket_booking_procedure_container {
        .procedure_form {
          width: 92%;
        }
      }
    }

			.__mobile_navigation {
				display: block;
				width: 100%;
				height: 9vh;
				background: $pureWhite;
				position: fixed;
				top: 0;
				z-index: 5;

				 & .logo_container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;

            .menu_toggle {
                width: 22%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }

            .--full_width {
                width: 100% !important;
                height: 50% !important;
            }

            .--sidebar_toggled_hide_logo {
                display: none !important;
            }

            .logo {
                width: 56%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
									width: 60%;
									margin-top: 0.2em;
                }
            }

            .settings {
							width: 22%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
            }
        }

			}

			.entire_app__sidebar_container{
				display: none;
			}

			.entire_app__page_content {
				display: block;
				width: 100%;

				.today {
					margin-top: 9vh;
					width: 100% !important;
          height: 140vh !important;

          h5 svg{
            display: none;
          }
          h5{
            margin-left: 5% !important;
          }

      .branches_performance {

        hr{
          display: none;
        }
        .performance_today {
          padding-left: 0 !important;
          padding-right: 0 !important;
          height: 60%;

          h6{
            margin-left: 1% !important;
            margin-bottom: 4% !important;
          }
          .boxes {
            height: 90%;

            .three {
              margin-bottom: 0 !important;
              display: flex;
              flex-wrap: wrap !important;
              justify-content: space-evenly;
              overflow: auto;
              height: 100%;

              .box1 {
                width: 45% !important;
                height: 32.5%;
                margin-bottom: 1.5% !important;

                img{
                  height: 50%;
                }
              }
              .issues{
                height: 15% !important;
              }
            }
          }
        }
        .day {
          height: 100%;
          display: flex;
          flex-wrap: wrap;
        }
        .branches_today {
          height: 50% !important;
        }
        .details-container{
          width: 98%;
        }
      }
			}
      .bordered {
        margin-right: 3%;
      }

      //lastweek performance
      .title2{
        margin-top: 12% !important;
      }
      .title{
        margin-top: 5% !important;
      }
      .small_p{
        margin-bottom: 2% !important;
      }
      .lastweek{
        display: flex;
        flex-direction: column !important;
      }
      .part-one,
      .part-two {
        width: 98% !important;
        margin: 5px 0 !important;
      }
      // .percentages-and-funds,.day-to-day-contribution,.Income-generation,.sold-tickets{
      //   overflow: auto;
      // }

				.notifications_container {
					display: none;
				}
			}

      .entire_app_mobile_sidebar_container {
        display: block;
        transition: all .5s ease;
        z-index: 4;
        width: 100%;
        height: 92vh;
        background: $pureWhite;
        position: fixed;
        top: 8vh;
        animation: slide_up .2s linear;
      }

      @keyframes slide_up {
        0% {
          top: 8vh;
        }50%{
          top: 5vh;
        }100%{
          top: 8vh;
        }
      }
		}
}
</style>
